import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { PaymentCollectorResponseDto } from '@domain/payment-collector/dtos/payment-collector.response.dto';
import { GetPaymentCollectorRequestDto } from '@domain/payment-collector/dtos/get-payment-collector.request.dto';
import { UpdateStatePaymentCollectorRequestDto } from '@domain/payment-collector/dtos/update-state-payment-collector.request.dto';
import { UpdatePaymentCollectorRequestDto } from '@domain/payment-collector/dtos/update-payment-collector.request.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
  providedIn: 'root',
})
export class PaymentCollectorService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('payment/collector');
  }

  get(request: GetPaymentCollectorRequestDto) {
    const queryUrl = `${this.getApiUrl()}/get`;
    return this.http.get<ApiResponse<PaymentCollectorResponseDto[]>>(queryUrl, {
      params: { ...request },
    });
  }

  show(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/show/${request.refId}`;
    return this.http.get<ApiResponse<PaymentCollectorResponseDto>>(queryUrl, {
      params: { ...request },
    });
  }

  update(request: UpdatePaymentCollectorRequestDto) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<ApiResponse<PaymentCollectorResponseDto>>(
      queryUrl,
      request,
    );
  }

  updateState(request: UpdateStatePaymentCollectorRequestDto) {
    const queryUrl = `${this.getApiUrl()}/${request.refId}/state`;
    return this.http.patch<ApiResponse<PaymentCollectorResponseDto>>(
      queryUrl,
      request,
    );
  }
}
